module.exports = __webpack_public_path__ + "img/background054.fccf2782.jpg";